import React, { useContext } from 'react';
import { Modal as ModalModule } from 'common';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;

const ClearAllModal = ({ data: { clearSelectedContacts }, modalId }) => {
	const { closeModal } = useContext(ModalContext);

	const onPrimaryButtonClick = () => {
		// clear grid selection
		clearSelectedContacts();

		// close the modal
		closeModal(modalId, ModalButtonActionType.Ok);
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Yes',
		onClick: onPrimaryButtonClick,
		dataqa: 'clear-all-yes-button',
	};

	const secondaryButton = {
		type: ModalButtonActionType.Cancel,
		text: 'No',
		dataqa: 'clear-all-no-button',
	};

	return (
		<Modal
			modalId={modalId}
			className="contacts contacts-clear-all-modal warning-modal"
			header="Clear Contacts"
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
			size="small"
		>
			<div className="body">
				<p>Clear all selected contacts?</p>
			</div>
		</Modal>
	);
};

export default ClearAllModal;
